<template>
  <fb-list-body :showPager="false" :showSearchForm="false" :showBtnGroup="false">

    <template slot="table">
      <el-table
          ref="table"
          :height="tableHeight + 'px'"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <template v-for="(item, index) in tableColumns">
          <el-table-column v-if="item.tableColumn && item.tableColumn.length" :label="$t(item.label)" align="center" :key="index">
            <el-table-column v-for="(t, tIndex) in item.tableColumn" :key="tIndex" :label="$t(t.label)" align="center">
              <el-table-column
                  v-for="(tc, tcIndex) in t.children"
                  :key="tcIndex"
                  :label="$t(tc.label)"
                  :prop="tc.prop"
                  width="130"
                  align="center"></el-table-column>
            </el-table-column>
          </el-table-column>

          <template v-else>
            <el-table-column v-if="item.children.length" :key="index" :prop="item.prop" :label="$t(item.label)" align="center">
              <el-table-column
                  v-for="(c, cIndex) in item.children"
                  :key="cIndex"
                  :label="$t(c.label)"
                  :prop="c.prop"
                  align="center"> </el-table-column>
            </el-table-column>

            <!-- 脂肪 -->
            <el-table-column v-else-if="item.prop === 'totalFat'" :key="index" :prop="item.prop" :label="$t(item.label)" align="center" width="150">
              <template v-slot="{row}">
                {{row | filterTotalFat}}
              </template>
            </el-table-column>

            <el-table-column v-else :key="index" :prop="item.prop" :label="$t(item.label)" align="center" width="150" :fixed="item.fixed" />
          </template>

        </template>

        <el-table-column :label="$t('操作')" fixed="right" align="center" width="150">
          <template v-slot="{row}">
            <el-button type="primary" @click="$router.push('/recommend/edit?age=' + row.age)">{{$t('编辑')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </fb-list-body>
</template>

<script>
import tableColumns, {fieldMap, formatField} from "./config"
import {request} from "@/config/request";
export default {
  name: "RecommendList",
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      tableColumns,
      tableHeight: 0,
    }
  },
  created() {
    this.handleLoadList();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize)
  },
  methods: {
    // 动态设置表格高度
    handleResize() {
      this.$nextTick(() => {
        const wrapper = document.querySelector(".tv-main-body");
        this.tableHeight = wrapper.clientHeight - 91;
      })
    },
    async handleLoadList() {
      try {
        const res = await request(this.$api.recommendCalorie.list);
        const sourceList = res.dataMapList;
        const list = [];
        for (const key in res.dataMapList) {
          const targetItem = {
            age: key
          }
          sourceList[key].forEach(item => {
            const name = formatField(item);
            const keyName = fieldMap[name];
            if(keyName === "totalFat") {
              targetItem["totalFatArea"] = item.elementValue2;
            }
            targetItem[keyName] = item.elementValue;
          })
          list.push(targetItem);
        }
        this.tableData = list.sort((a, b) => {
          return a.age - b.age;
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
  filters: {
    filterTotalFat(row) {
      if(!row.totalFatArea) return row.totalFat;
      return `${row.totalFat}~${row.totalFatArea}`
    }
  }
}
</script>

<style scoped>

</style>
